import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import httpRequest from "../HttpRequestService";

const Pass = ({ pass, load, token }) => {
    const [ussd, setUssd] = useState('#111*1*6*1#');
    const [ussdCode, setUssdCode] = useState(null);
    const [name, setName] = useState(pass.name);
    const [canRetrait, setCanRetrait] = useState(pass.canRetrait);
    const [canUssd, setCanUssd] = useState(pass.canUssd);
    const [code, setCode] = useState(pass.code);
    const [isTpe, setIsTpe] = useState(pass.isTpe);
    const [isTpeRetrait, setIsTpeRetrait] = useState(pass.isTpeRetrait);
    const [isCashPoint, setIsCashPoint] = useState(pass.isCashPoint);
    const [imei, setImei] = useState(pass.imei);
    const [p_adresse, setP_adresse] = useState(pass.proprietaire.adresse);
    const [p_contact, setP_contact] = useState(pass.proprietaire.contact);
    const [p_name, setP_name] = useState(pass.proprietaire.name);
    const [p_nameResponsable, setP_nameResponsable] = useState(pass.proprietaire.nameResponsable);
    const [operateur_first_name, setOperateur_first_name] = useState(pass.operateur[0]?.name || '');
    const [operateur_first_operateur, setOperateur_first_operateur] = useState(pass.operateur[0]?.operateur || '');
    const [operateur_first_phone, setOperateur_first_phone] = useState(pass.operateur[0]?.phone || '');
    const [operateur_second_name, setOperateur_second_name] = useState(pass.operateur[1]?.name || '');
    const [operateur_second_operateur, setOperateur_second_operateur] = useState(pass.operateur[1]?.operateur || '');
    const [operateur_second_phone, setOperateur_second_phone] = useState(pass.operateur[1]?.phone || '');
    const [code_merchant, setCode_merchant] = useState(pass.code_merchant);
    const [number_merchant, setNumber_merchant] = useState(pass.number_merchant);
    const [retrait_type, setRetrait_type] = useState('to_merchant');
    const [retrait_amount, setRetrait_amount] = useState(0);

    const apiCall = async (endpoint, data, successCb) => {
        try {
            const response = await httpRequest(`${token}/myPasserelle/${endpoint}`, { data }, false);
            if (response.data) {
                alert(response.data.message);
                if (successCb) successCb();
            }
        } catch (error) {
            alert(error.response?.data?.message || 'Erreur');
            console.error(error.response?.data);
        }
    };

    const updatePass = () => apiCall('Update', {
        id: pass._id, name, canRetrait, canUssd, code, isTpe, isTpeRetrait, isCashPoint, imei,
        code_merchant, number_merchant,
        proprietaire: { adresse: p_adresse, contact: p_contact, name: p_name, nameResponsable: p_nameResponsable },
        operateur: [
            { name: operateur_first_name, operateur: operateur_first_operateur, phone: operateur_first_phone },
            { name: operateur_second_name, operateur: operateur_second_operateur, phone: operateur_second_phone }
        ]
    }, load);

    const sendUssd = () => apiCall('SendUssd', { imei, ussd, code: ussdCode });
    const restart  = () => apiCall('Restart', { imei });
    const sendRetrait = () => apiCall('SendRetrait', { imei, retrait_type, retrait_amount });

    return (
        <>
            {/* ── Soldes ─────────────────────────────────────── */}
            <p className="section-title">Soldes</p>
            <Row className="g-3 mb-4">
                <Col xs={4}>
                    <div className="balance-pill balance-telma">
                        <span>Telma / mVola</span>
                        {(pass.solde?.telma ?? 0).toLocaleString('fr')} Ar
                    </div>
                </Col>
                <Col xs={4}>
                    <div className="balance-pill balance-orange">
                        <span>Orange Money</span>
                        {(pass.solde?.orange ?? 0).toLocaleString('fr')} Ar
                    </div>
                </Col>
                <Col xs={4}>
                    <div className="balance-pill balance-airtel">
                        <span>Airtel Money</span>
                        {(pass.solde?.airtel ?? 0).toLocaleString('fr')} Ar
                    </div>
                </Col>
            </Row>

            {/* ── Envoyer USSD ───────────────────────────────── */}
            <p className="section-title">Envoyer une commande USSD</p>
            <Row className="g-2 mb-3 align-items-end">
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Code USSD</Form.Label>
                    <Form.Control size="sm" value={ussd} onChange={(e) => setUssd(e.target.value)} />
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Réponse USSD</Form.Label>
                    <Form.Control size="sm" placeholder="Code réponse (optionnel)" value={ussdCode || ''} onChange={(e) => setUssdCode(e.target.value || null)} />
                </Col>
                <Col xs="auto">
                    <Button variant="primary" size="sm" onClick={sendUssd}>Envoyer</Button>
                </Col>
            </Row>

            {/* ── Transaction manuelle ───────────────────────── */}
            <p className="section-title">Transaction entre comptes</p>
            <Row className="g-2 mb-4 align-items-end">
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Type</Form.Label>
                    <Form.Select size="sm" value={retrait_type} onChange={(e) => setRetrait_type(e.target.value)}>
                        <option value="to_merchant">OrangeMoney → Marchand (orange)</option>
                        <option value="merchant_to_merchant">Marchand → Marchand (orange)</option>
                        <option value="merchant_to_orangemoney">Marchand → OrangeMoney</option>
                        <option value="orangemoney_to_orangemoney">OrangeMoney → OrangeMoney</option>
                        <option value="to_mvola">TPE mVola → mVola (Telma)</option>
                        <option value="gp_to_mvola">mVola → mVola (Telma)</option>
                    </Form.Select>
                </Col>
                <Col xs={3}>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Montant</Form.Label>
                    <Form.Control size="sm" type="number" min="0" value={retrait_amount} onChange={(e) => setRetrait_amount(e.target.value === '' ? 0 : +e.target.value)} />
                </Col>
                <Col xs="auto">
                    <Button variant="outline-danger" size="sm" onClick={sendRetrait}>Envoyer</Button>
                </Col>
            </Row>

            {/* ── Organisation ───────────────────────────────── */}
            <p className="section-title">Organisation</p>
            <Row className="g-2 mb-3">
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Nom</Form.Label>
                    <Form.Control size="sm" value={p_name} onChange={(e) => setP_name(e.target.value)} />
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Adresse</Form.Label>
                    <Form.Control size="sm" value={p_adresse} onChange={(e) => setP_adresse(e.target.value)} />
                </Col>
            </Row>
            <Row className="g-2 mb-3">
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Contact</Form.Label>
                    <Form.Control size="sm" value={p_contact} onChange={(e) => setP_contact(e.target.value)} />
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Responsable</Form.Label>
                    <Form.Control size="sm" value={p_nameResponsable} onChange={(e) => setP_nameResponsable(e.target.value)} />
                </Col>
            </Row>
            <Row className="g-2 mb-4">
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Code marchand (Orange)</Form.Label>
                    <Form.Control size="sm" value={code_merchant} onChange={(e) => setCode_merchant(e.target.value)} />
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Numéro pour transaction</Form.Label>
                    <Form.Control size="sm" value={number_merchant} onChange={(e) => setNumber_merchant(e.target.value)} />
                </Col>
            </Row>

            {/* ── Passerelle ─────────────────────────────────── */}
            <p className="section-title">Passerelle</p>
            <Row className="g-2 mb-3">
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Nom</Form.Label>
                    <Form.Control size="sm" value={name} onChange={(e) => setName(e.target.value)} />
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>IMEI</Form.Label>
                    <Form.Control size="sm" value={imei} onChange={(e) => setImei(e.target.value)} />
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>Code</Form.Label>
                    <Form.Control size="sm" value={code} onChange={(e) => setCode(e.target.value)} />
                </Col>
            </Row>

            {/* ── Opérateurs ─────────────────────────────────── */}
            <p className="section-title">Opérateurs</p>
            <Row className="g-2 mb-2">
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>P1 — Nom</Form.Label>
                    <Form.Control size="sm" value={operateur_first_name} onChange={(e) => setOperateur_first_name(e.target.value)} />
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>P1 — Opérateur</Form.Label>
                    <Form.Select size="sm" value={operateur_first_operateur} onChange={(e) => setOperateur_first_operateur(e.target.value)}>
                        <option value="telma">Telma</option>
                        <option value="orange">Orange</option>
                        <option value="airtel">Airtel</option>
                    </Form.Select>
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>P1 — Numéro</Form.Label>
                    <Form.Control size="sm" value={operateur_first_phone} onChange={(e) => setOperateur_first_phone(e.target.value)} />
                </Col>
            </Row>
            <Row className="g-2 mb-4">
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>P2 — Nom</Form.Label>
                    <Form.Control size="sm" value={operateur_second_name} onChange={(e) => setOperateur_second_name(e.target.value)} />
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>P2 — Opérateur</Form.Label>
                    <Form.Select size="sm" value={operateur_second_operateur} onChange={(e) => setOperateur_second_operateur(e.target.value)}>
                        <option value="telma">Telma</option>
                        <option value="orange">Orange</option>
                        <option value="airtel">Airtel</option>
                    </Form.Select>
                </Col>
                <Col>
                    <Form.Label style={{ fontSize: '12px', color: '#6c757d' }}>P2 — Numéro</Form.Label>
                    <Form.Control size="sm" value={operateur_second_phone} onChange={(e) => setOperateur_second_phone(e.target.value)} />
                </Col>
            </Row>

            {/* ── Options ────────────────────────────────────── */}
            <p className="section-title">Options</p>
            <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', marginBottom: '20px' }}>
                {[
                    [isTpe, setIsTpe, 'isTpe', 'TPE'],
                    [isTpeRetrait, setIsTpeRetrait, 'isTpeRetrait', 'TPE Retrait'],
                    [isCashPoint, setIsCashPoint, 'isCashPoint', 'Cash Point'],
                    [canRetrait, setCanRetrait, 'canRetrait', 'Retrait autorisé'],
                    [canUssd, setCanUssd, 'canUssd', 'USSD autorisé'],
                ].map(([val, setter, id, label]) => (
                    <Form.Check
                        key={id}
                        type="switch"
                        id={id}
                        label={label}
                        checked={val}
                        onChange={(e) => setter(e.target.checked)}
                        style={{ fontSize: '13px' }}
                    />
                ))}
            </div>

            {/* ── Actions ────────────────────────────────────── */}
            <div style={{ display: 'flex', gap: '10px' }}>
                <Button variant="primary" size="sm" onClick={updatePass}>
                    💾 Mettre à jour
                </Button>
                <Button variant="outline-warning" size="sm" onClick={restart}>
                    🔄 Redémarrer
                </Button>
            </div>
        </>
    );
};

export default Pass;
